import { enumCommentStatusFlowStatus, enumStarScoreFlowStatus } from '../../../types/enums/status';
import AssignmentIcon from "@mui/icons-material/Assignment";
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import StarIcon from '@mui/icons-material/Star';
  

export const initialState = {
  commentList: [],
  commentListEnd: [],
  selectedRow: {},   
  loading: false,
  paginationInfo: {
    rowsPerPage: 20,
    pageCount: 0,
    totalCount: 0,
    currentPage: 0,
  },filterInfo: {
    optionId: "",
    createDate: "",
    endDate: "",
    specialCode: "",
    colorCode: "",
    starScore:null,
    commentStatus:[{id: 1}], 
    tagName:[],
    operator:"",
    grievanceStatus:[{id: 2,value:"Tümü"}], 
    hasPhoto: 2,
  },

};
export const starScoreLookupList = [

  {
    id: enumStarScoreFlowStatus.one,
    value: "1",
  },
  {
    id: enumStarScoreFlowStatus.two,
    value: "2",
  },
  {
    id: enumStarScoreFlowStatus.three,
    value: "3",
  },
  {
    id: enumStarScoreFlowStatus.four,
    value: "4",
  },
  {
    id: enumStarScoreFlowStatus.five,
    value: "5",
  },
];
export const commentStatusLookupList = [
  {
    id: enumCommentStatusFlowStatus.minusOne,
    value: "Tümü",
  },
  {
    id: enumCommentStatusFlowStatus.one,
    value: "Onay Bekliyor",
  },
  {
    id: enumCommentStatusFlowStatus.two,
    value: "Onaylandı",
  },
  {
    id: enumCommentStatusFlowStatus.three,
    value: "Reddedildi",
  },
];
export const tableHeadList = [
  {
    id: "id",
    numeric: false,
    disablePadding: true,
    label: "Yorum Id",
    cellType: 0,
  },
   
  {
    id: "mail",
    numeric: false,
    disablePadding: true,
    label: "E-mail",
    cellType: 0,
  },
  {
    id: "special",
    numeric: false,
    disablePadding: true,
    label: "Özel Kod",
    cellType: 0,

  },
  {
    id: "colorCode",
    numeric: false,
    disablePadding: true,
    label: "Renk Kodu",     
    cellType: 0,
  },

  {
    id: "commentStatus",
    numeric: false,
    disablePadding: true,
    label: "Yorum Statü",
    cellType: 2,
  },
   {
    id: "status",
    numeric: false,
   disablePadding: true,
   label: "Puan",
   icon: StarIcon,
   cellType: 3,

 },
  {
    id: "createDate",
    numeric: false,
    disablePadding: true,
    label: "Yorum Tarihi",  
    cellType: 0,
  },
  {
    id: "grievanceStatus",
    numeric: false,
    disablePadding: true,
    label: "Mağduriyet",  
    cellType: 2,
  },
  {
    id: "operator",
    numeric: false,
    disablePadding: true,
    label: "Atanan Kişi",  
    cellType: 0,
  },
  {
    id: "tag",
    numeric: false,
    disablePadding: true,
    label: "Etiket",
    cellType: 0,
  },
  
 {
   id: "detay",
   numeric: false,
  disablePadding: true,
  label: "Detay",
  icon: AssignmentIcon,
  cellType: 1,
  className: "detailButton",
},
{
  id: "banaAta",
  numeric: false,
 disablePadding: true,
 label: "Bana Ata",
 icon: AssignmentIndIcon,
 cellType: 1,
 className: "detailButton",
},
  ];
  export type IRow = {
    
    name: string;
    createDate: string;
    status: IRowCellStatus;
    description: string;
  };
  
  export type IRowCellUrl = {
    url: string | null;
    text: string;
  };
  
  export type IRowCellStatus = {
    className: string;
    id: number;
    text: string;
  };
  
